const state = {
  isNewPage: true,
  power: {},
  menuList: [],
  isLoading: null
}

export default state